const InfoBackground = ({children, className}) => (
    <div className={`p-3 ${className ? className : ""}`}style={{background: "#ECF2FF", color: "#343A40"}}>
        {children}
    </div>
)

export default InfoBackground